<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <!-- Add IP Input + Button -->
            <div class="col-12 col-lg-4 mb-2 mb-lg-0 d-flex gap-2">
               <input v-model="inputIP" type="text" class="form-control form-control-sm"
                  placeholder="&#xF002; Add IP address..."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;"
                  v-on:keyup.enter="onEnter" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="fw-bold btn text-light btn-sm"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem; white-space: nowrap; background: #00a0c1;"
                  @click="sendData">
                  <i class="fa-solid fa-plus-circle me-1"></i> Add IP
               </button>
            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <tbody v-if="IPs.length <= 0">
                  <tr>
                     <td colspan="2">No IP addresses added yet.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(IP, index) in IPs" :key="index">
                     <td style="font-family: monospace; font-size: 13px;">{{ IP.ip }}</td>
                     <td style="width: 80px;">
                        <button type="button" class="ms-action-btn ms-action-btn--delete"
                           
                           @click="deleteIP(index)" title="Remove">
                           <i class="fa fa-xmark"></i>
                        </button>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
</template>

<script>
import { extractErrorMessage } from '@/plugins/helper.js'

export default {

   components: {},

   data() {
      return {
         headers: [
            { text: "IP Address", value: "ip" },
            { text: "Action", value: "action" },
         ],
         IPs: [],
         inputIP: "",
      };
   },

   mounted() { this.init(); },

   methods: {
      init() { this.getIPs() },
      onEnter() { this.sendData() },

      async getIPs() {
         await this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-ips")
            .then((response) => { this.IPs = response.data.account_ips })
            .catch((error) => {
               console.log(error)
               this.$toast.error(extractErrorMessage(error, "Failed to load IP list."))
            })
      },

      async sendData() {
         try {
            if (this.inputIP == "" || this.inputIP == null || this.isValidIPV4(this.inputIP) == false) {
               this.$toast.error("Please provide a valid IP."); return
            }
            const payload = { ip: this.inputIP }
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/add-account-ip", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getIPs()
            }
            this.inputIP = ""
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to add IP address."))
            this.inputIP = ""
         }
      },

      async deleteIP(index) {
         try {
            const payload = { ip: this.IPs[index].ip, id: this.IPs[index].id }
            const resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-account-ip/" + this.IPs[index].id, payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getIPs()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to remove IP address."))
         }
      },

      isValidIPV4(ipv4) {
         const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
         return ipv4Pattern.test(ipv4);
      },
   }
}
</script>

<style scoped>
.card { border: none; }
</style>